module.exports = __webpack_public_path__ + "static/image6-d5b662ddf0fcbaf5f631baa52365656d.jpeg";